/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.admpb = require('./fielddefinition_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.FieldDefinitionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.FieldDefinitionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ReadFieldDefinitionRequest,
 *   !proto.admpb.ReadFieldDefinitionResponse>}
 */
const methodDescriptor_FieldDefinitionService_ReadFieldDefinition = new grpc.web.MethodDescriptor(
  '/admpb.FieldDefinitionService/ReadFieldDefinition',
  grpc.web.MethodType.UNARY,
  proto.admpb.ReadFieldDefinitionRequest,
  proto.admpb.ReadFieldDefinitionResponse,
  /**
   * @param {!proto.admpb.ReadFieldDefinitionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadFieldDefinitionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.ReadFieldDefinitionRequest,
 *   !proto.admpb.ReadFieldDefinitionResponse>}
 */
const methodInfo_FieldDefinitionService_ReadFieldDefinition = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ReadFieldDefinitionResponse,
  /**
   * @param {!proto.admpb.ReadFieldDefinitionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadFieldDefinitionResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ReadFieldDefinitionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ReadFieldDefinitionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadFieldDefinitionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.FieldDefinitionServiceClient.prototype.readFieldDefinition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.FieldDefinitionService/ReadFieldDefinition',
      request,
      metadata || {},
      methodDescriptor_FieldDefinitionService_ReadFieldDefinition,
      callback);
};


/**
 * @param {!proto.admpb.ReadFieldDefinitionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadFieldDefinitionResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.FieldDefinitionServicePromiseClient.prototype.readFieldDefinition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.FieldDefinitionService/ReadFieldDefinition',
      request,
      metadata || {},
      methodDescriptor_FieldDefinitionService_ReadFieldDefinition);
};


module.exports = proto.admpb;

